/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'
import traceBotSoccer from '../../../assets/img/Trace-Bot-Soccer.svg'
import './Waiting.css'

/*
 * Props
 *
 * backPressed
 */

export default class Waiting extends Component {

    constructor() {
        super()
        this.backPressed = this.backPressed.bind(this)
    }

    backPressed() {
        this.props.backPressed()
    }

    render() {
        var styles = {}
        if (this.props.show === false) {
            styles = { display: 'none' }
        }

        return (
            <div className="Waiting" style={styles}>
                <h2>Uploading in progress...</h2>
                <p>Please do not close this browser tab<br />until all videos files are uploaded</p>
                <img alt="waiting" className="waiting-robot" src={traceBotSoccer} />
            </div>
        )
    }

}
